import TagManager from "react-gtm-module";

export const initializeTagManager = () => {
    TagManager.initialize({
      gtmId: 'G-61PRTEH7LZ'
    });
  };
